import { cva, VariantProps } from 'class-variance-authority'
import { PropsWithChildren } from 'react'
import { cn } from '../../utils/cn'

const typographyStyles = cva('', {
  variants: {
    weight: {
      normal: 'font-normal',
      bold: 'font-bold',
      medium: 'font-medium',
    },
    size: {
      h1: 'text-[3.812rem]', // 62px
      h2: 'text-[3.062rem]', // 50px
      h3: 'text-[2.438rem]', // 35px
      h4: 'text-[1.938rem]', // 30px
      h5: 'text-[1.562rem]', // 25px
      h6: 'text-[1.250rem]', // 20px
      xLarge: 'text-[1.562rem]', // 25px
      large: 'text-[1.250rem]', // 20px
      base: 'text-[1rem]', // 16px
      small: 'text-[0.812rem]', // 13px
      mini: 'text-[0.625rem]', // 10px
    },
    alignX: {
      left: 'text-left',
      center: 'text-center',
      right: 'text-right',
    },
    alignY: {
      top: 'align-top',
      middle: 'align-middle',
      bottom: 'align-bottom',
    },
  },
  defaultVariants: {
    weight: 'normal',
    alignX: 'left',
    alignY: 'top',
  },
})

type TypographyElements =
  | 'h1'
  | 'h2'
  | 'h3'
  | 'h4'
  | 'h5'
  | 'h6'
  | 'div'
  | 'span'
  | 'p'
  | 'a'

type Props = VariantProps<typeof typographyStyles> &
  PropsWithChildren<{
    element?: TypographyElements
    className?: string
    color?: string
    href?: string
  }>

const Typography = ({
  element = 'div',
  className,
  children,
  weight,
  alignX,
  alignY,
  size,
  color = 'text-content-default',
  ...props
}: Props) => {
  const Tag = element
  return (
    <Tag
      className={cn(
        typographyStyles({
          weight,
          alignX,
          alignY,
          size,
        }),
        color,
        className
      )}
      {...props}
    >
      {children}
    </Tag>
  )
}

export default Typography
